import { useMemo } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { EmailIntegrationTable } from 'features/settings/components/EmailIntegrationTable'
import { EmailIntegrationSignatures } from 'features/settings/components/EmailIntegrationSignatures'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

export function EmailIntegrationSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const featureFlags = useFeatureFlagService()

  const tabs = useMemo(() => {
    const allTabs: { key: string; title: string }[] = [
      { key: 'connections', title: 'Connections' },
    ]

    if (featureFlags.enableEmailSignature) {
      allTabs.push({ key: 'signatures', title: 'Signatures' })
    }

    return allTabs
  }, [featureFlags.enableEmailSignature])

  const defaultTab = tabs[0]?.key ?? 'connections'
  const tab = params.tab ?? defaultTab

  if (!featureFlags.enableEmailIntegration) {
    return <Navigate to="/settings/team/users" replace />
  }

  if (params.tab && !tabs.some((t) => t.key === params.tab)) {
    return <Navigate to={`/settings/email-integration/${defaultTab}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) =>
            navigate(`/settings/email-integration/${value}`)
          }
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer hide={tab !== 'connections'}>
        <EmailIntegrationTable />
      </FBPageTableContainer>
      {featureFlags.enableEmailSignature && (
        <FBPageTableContainer hide={tab !== 'signatures'}>
          <EmailIntegrationSignatures />
        </FBPageTableContainer>
      )}
    </div>
  )
}
